import React, {useState} from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import authApi from "../api/authApi";
// import home from "../resources/img/homelogo.png"
import homeBanner from "../resources/img/homeBanner.jpg"
import indicrm from "../resources/img/indicrm.png"


const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({email: "", password : ""});
  const [show, setShow] = React.useState(false);
  const [errorMessage,setErrorMessage] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await authApi.login(credentials.email, credentials.password)
    if (result.success) {
      localStorage.setItem("token", result.authToken);
      localStorage.setItem("username",result.username);
      let data =  await authApi.fetchMyImage();
      if(data)
        localStorage.setItem("myimage", window.URL.createObjectURL(data));
      else
        localStorage.setItem("myimage", "https://www.w3schools.com/howto/img_avatar.png");
      navigate("/dashboard");
    }else {
      setShow(true);
      setErrorMessage(result.errors);

    }
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  return (
    <Container>
      <Row className="login-form p-3 mt-5">
        <Col lg={6}>
        <img src="https://i.postimg.cc/5N1zV0VK/banner-Cargo.jpg" style={{display: "flex", alignItems: "center", height: "250px", marginTop: "100px" ,width: "100%"}} alt=""/>
        </Col>
        <Col lg={6} className="login-section">
          {/* <h3 className="text-center mb-2"></h3> */}
          <div className="p-5">
            <Form onSubmit={handleSubmit}>
              <div className="mb-2">
              <center>
              <img style={{ width: "220px", height: "180px" }} className="pt-6" src='https://i.ibb.co/MyY2Hds3/gncm-final-logo-2.jpg' alt="" />
              <p style={{alignItems: "center"}}>Bharosa Har Load Ka, Safar Har Road Ka!</p>
              {/* src={home} */}
            </center>
            
              </div>
              <div className="p-5">
                <div className="mt-2 text-center mb-4">
                  <i className="fa-solid fa-lock-open fa-2xl"></i>
                  <h3 className="mt-2">Login</h3>
                </div>
                <Alert variant="danger" show={show}>{errorMessage}</Alert>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter email"
                  value={credentials.email}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  onChange={handleChange}
                  placeholder="Password"
                  value={credentials.password}
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                Login
              </Button>
              <Link to={"/"} >
              <Button variant="success" link className="mx-3">
              Switch to GN Trailer and Transport
              </Button>
               </Link>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
      {/* <center className="m-4"><img src={indicrm} alt="" /></center> */}
    </Container>
  );
};

export default Login;
